module.exports = __webpack_public_path__ + "menu_3.e3c87958.png";